export const projects = [
  {
    title: "E-commerce Platform",
    description: "AttireX is a fashion e-commerce website that aims to provide a seamless and enjoyable shopping experience for customers looking to explore and purchase the latest fashion trends..",
    language: "React",
    lastUpdated: "last year",
    url: "/chat/2",
    stars: 8,
    contributors: 1
  },
  {
    title: "CodeCompass.AI",
    description: " Save time, boost productivity, and ensure seamless knowledge transfer across your organization. Transform how your team navigates project information.",
    language: "NextJS",
    lastUpdated: "a day ago",
    url: "/chat/3",
    stars: 2,
    contributors: 2
  },
  {
    title: "Git Repo Parser",
    description: "A tool to scrape all files from a GitHub repository and turn it into a JSON or TXT file, Useful for AI and LLM Projects.",
    language: "Typescript",
    lastUpdated: "3 days ago",
    stars: 2,
    url: "/chat/1",
    contributors: 1
  }
];
